import { defineStore } from 'pinia'
import tool from '@/utils/tool'
import loginApi from '@/api/auth/loginApi'
import statisticsApi from '@/api/biz/statisticsApi'
import dictApi from '@/api/dev/dictApi'
import bizBasicConfigApi from '@/api/dev/basicConfigApi'
import jobapplyApi from '@/api/user/jobapplyApi'
import fusionquestionrecordApi from '@/api/fusion/fusionquestionrecordApi'
import companyinfoApi from '@/api/firmCenter/companyinfoApi'
import resumeApi from '@/api/biz/resumeApi'

/**
 * deprecated 请使用 useSserStore
 */
export const userStore = defineStore({
	id: 'user',
	state: () => ({
			// 用户信息
			userInfo: tool.session.get('USER_INFO') || {},
			companyInfo: tool.session.get('COMPANY_INFO') || {},
			// HR详情数据（从sessionStorage恢复）
			hrDetail: tool.session.get('HR_DETAIL') || {},
			// 个人中心统计数据
			statisticsData: {
			deliverCount: 0,
			sendInterviewCount: 0,
			collectJobCount: 0,
			collectCompanyCount: 0
		},
		// 企业收到投递代办数
		agencyCount: 0,
		// 企业监测指标汇报待提交数
		unSubmitCount: 0,
		currentUserType: parseInt(tool.data.get('currentUserType')||'1'),
		// 简历预览数据缓存（避免 layout 和 personalCenter 重复调用 userResumeView）
		resumeViewData: null,
		resumeViewPromise: null
	}),
	actions: {
		// 获取用户信息
		async getUserInfo() {
			const res = await loginApi.getLoginUser()
			tool.session.set('USER_INFO', res)
			this.userInfo = res
		},
		// 获取企业信息
		async getCompanyInfo() {
			companyinfoApi.detail({ id: this.userInfo.companyId }).then(res => {
				this.companyInfo= res
			})
		},
		// 清楚信息
		clearUserInfo() {
			this.userInfo = {}
			this.resumeViewData = null
			this.resumeViewPromise = null
		},
		// 获取企业监测指标汇报待提交数
		getUnSubmitCount() {
			fusionquestionrecordApi.unSubmitRecordCount().then((res) => {
				this.unSubmitCount = res
			})
		},
		// 获取代办数
		getAgencyCount() {
			jobapplyApi.enterprisePendTotal().then((res) => {
				this.agencyCount = res.paddingApply
			})
		},
		// 获取个人中心统计数据
		getStatisticsData() {
			statisticsApi.userResume().then((res) => {
				this.statisticsData = res
			})
		},
		// 获取字典数据
		getDict() {
			return new Promise(async (resolve, reject) => {
				try {
					// 获取系统字典
					let res1 = await dictApi.dictTree()
                    tool.data.set('DICT_TYPE_TREE_DATA', res1)
					// 获取专业
					let res2 = await bizBasicConfigApi.basicTree({ category: 'MAJOR' })
                    tool.data.set('DICT_MAJOR', res2 || [])
					// 获取职位
					let res3 = await bizBasicConfigApi.basicTree({ category: 'JOB' })
                    tool.data.set('DICT_JOB', res3 || [])
					// 获取地区
					let res4 = await bizBasicConfigApi.basicTree({ category: 'DISTRICT' })
                    tool.data.set('DICT_DISTRICT', res4 || [])
                    resolve(true)
				} catch (error) {
                    reject(error)
                }
			})
		},
		changeCurrentUserType(type) {
			const value = Number(type) || 1
			this.currentUserType = value
			tool.data.set('currentUserType', String(value))
			// 切换身份时清空简历预览缓存
			this.resumeViewData = null
			this.resumeViewPromise = null
		},
		// 获取简历预览数据（带缓存，避免重复调用）
		getResumeView() {
			if (this.resumeViewData) return Promise.resolve(this.resumeViewData)
			if (this.resumeViewPromise) return this.resumeViewPromise
			this.resumeViewPromise = resumeApi.userResumeView().then(res => {
				this.resumeViewData = res
				this.resumeViewPromise = null
				return res
			}).catch(err => {
				this.resumeViewPromise = null
				throw err
			})
			return this.resumeViewPromise
		},
		// 清空简历预览缓存（编辑简历后调用以刷新数据）
		clearResumeView() {
			this.resumeViewData = null
			this.resumeViewPromise = null
		},
		setHrDetail(data) {
			this.hrDetail = data
			tool.session.set('HR_DETAIL', data)
		}
	}
})

export const useUserStore = userStore
